import { render } from "./ParagraphHeader.vue?vue&type=template&id=5b1cf381"
import script from "./ParagraphHeader.vue?vue&type=script&lang=js"
export * from "./ParagraphHeader.vue?vue&type=script&lang=js"

import "./ParagraphHeader.vue?vue&type=style&index=0&id=5b1cf381&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__